import React from 'react';
import {} from //personOutline,
// chevronBack,
//chevronDown,
//medkitOutline,
'ionicons/icons';
import { IonContent, IonPage } from '@ionic/react';
// import { IonicButton } from 'ionic-ui';
import AuthBanner from '../../components/auth-components/AuthBanner';
import AuthLayoutHeader from '../../components/auth-components/AuthLayoutHeader';

export interface LayoutProps {
  children?: React.ReactNode;
  uiType: 'signin' | 'signup';
  uiFor?: 'user' | 'expert';
  title?: string;
  description: string;
  step?: number;
  totalStep?: number;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  uiType,
  //uiFor,
  title = "Let's get started!",
  description,
  step = 1,
  totalStep,
}) => {
  return (
    <IonPage>
      <IonContent fullscreen>
        <div
          //onClick={() => setShowSignMenu(false)}
          className=" py-6  h-full relative bg-background dark:bg-background-accent  "
        >
          <div className="parent-container h-full dashboard-scroller overflow-y-auto overflow-x-hidden flex gap-6">
            {/* Left Side */}
            <div
              className={`w-full md:flex-1 min-h-fit h-full flex flex-col md:justify-center `}
            >
              <div
                className={`w-full min-h-fit h-full sm:mx-auto ${uiType == 'signup' ? 'md:p-6' : 'md:p-6  md:border md:border-border md:rounded-md'}`}
              >
                {/**Form container */}
                <div className="w-full h-fit flex items-start justify-center">
                  <div className="flex-grow max-w-md space-y-4">
                    {/**Mobile-only logo */}
                    <AuthLayoutHeader
                      title={title}
                      totalSteps={totalStep}
                      step={step}
                      uiType={uiType}
                      description={description}
                    />

                    {children}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <AuthBanner className="flex-1" />
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Layout;
